import Image from "next/image";
import { FileType } from "../../models/funUgc.model";
import styles from "./ProductTag.module.scss";
import DubIcon from "../../../../../../../shared-assets/images/funUgc/player/DubIcon.png";
import StoryIcon from "../../../../../../../shared-assets/images/funUgc/player/StoryIcon.png";
import PaintingIcon from "../../../../../../../shared-assets/images/funUgc/player/PaintingIcon.png";
import ColoringIcon from "../../../../../../../shared-assets/images/funUgc/player/ColoringIcon.png";
import GalleryIcon from "../../../../../../../shared-assets/images/funUgc/player/GalleryIcon.png";
import DubsmashIcon from "../../../../../../../shared-assets/images/funUgc/player/DubsmashIcon.png";

interface ProductTagProps {
  fileType: FileType;
}

export function ProductTag({ fileType }: ProductTagProps) {
  return (
    <div className={styles.productTagWrapper}>
      <div className={styles.tagImageWrapper}>
        {fileType === "Dub" && <Image src={DubIcon} alt="" layout="fill" />}
        {fileType === "Story" && <Image src={StoryIcon} alt="" layout="fill" />}
        {fileType === "Painting" && (
          <Image src={PaintingIcon} alt="" layout="fill" />
        )}
        {fileType === "Coloring" && (
          <Image src={ColoringIcon} alt="" layout="fill" />
        )}
        {fileType === "Gallery" && (
          <Image src={GalleryIcon} alt="" layout="fill" />
        )}
        {fileType === "Dubsmash" && (
          <Image src={DubsmashIcon} alt="" layout="fill" />
        )}
      </div>

      <div className={styles.tagName}>
        {fileType === "Dub" && "دوبله"}
        {fileType === "Story" && "قصه"}
        {fileType === "Painting" && "نقاشی"}
        {fileType === "Coloring" && "رنگ‌آمیزی"}
        {fileType === "Gallery" && "گالری"}
        {fileType === "Dubsmash" && "دابسمش"}
      </div>
    </div>
  );
}
